import { render, staticRenderFns } from "./AddRegulationPopup.vue?vue&type=template&id=20bbafb1"
import script from "./AddRegulationPopup.vue?vue&type=script&lang=js"
export * from "./AddRegulationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports